import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IBreak, ISimpleTime } from "../../models"
import AddBreakDialog from "./AddBreakDialog"
import * as scheduleHelper from "../../helpers/scheduleHelper"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
  breaks: IBreak[]
  shiftStartTime: ISimpleTime
  shiftEndTime: ISimpleTime
  isEdit: boolean
  handleChange(breaks: IBreak[]): void
}
interface IState {
  breaks: IBreak[]
  openAddBreakDialog: boolean
  editBreak: IBreak
}

export default class BreaksChip extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      breaks: props.breaks,
      openAddBreakDialog: false,
      editBreak: null,
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ breaks: nextProps.breaks })
  }

  handleDelete(breakItem) {
    let breaks = this.state.breaks.slice()
    if (this.props.isEdit) {
      breaks.forEach(item => {
        if (item.Name === breakItem.Name) {
          item.Deleted = true
        }
      })
    }
    else {
      breaks = breaks.filter((item) => item.Name !== breakItem.Name)
    }

    this.setState({ breaks }, () =>
      this.props.handleChange && this.props.handleChange(breaks)
    )
  }

  handleAdd(breakItem) {
    const breaks = this.state.breaks.slice()
    breaks.push(breakItem)
    this.setState({ breaks, openAddBreakDialog: false, editBreak: null }, () => {
      this.props.handleChange && this.props.handleChange(breaks)
    })
  }

  handleUpdate(breakItem) {
    const breaks = this.state.breaks.slice()
    const indexOf = this.state.breaks.indexOf(this.state.editBreak)
    breaks[indexOf] = breakItem
    this.setState({ breaks, openAddBreakDialog: false, editBreak: null }, () => {
      this.props.handleChange && this.props.handleChange(breaks)
    })
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        <span style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13, marginLeft: 5 }}>{strings.Breaks}</span>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: -7, paddingBottom: 5 }}>
          {this.state.breaks.filter((item) => !item.Deleted).map((item, index) =>
            <Chip
              data-intercom-target={"Select-Break"}
              style={{ marginTop: 10, marginRight: 5, height: 35 }}
              key={index}
              onRequestDelete={item.Used ?
                null :
                () => AppStateStore.setConfirmDialogContent({
                  content: strings.Are_you_sure_you_want_to_delete_this_break,
                  confirm: () => this.handleDelete(item)
                })
              }
              onClick={() => !AppStateStore.confirmDialogContent &&
                this.setState({ openAddBreakDialog: true, editBreak: item })
              }
              labelStyle={{ width: 100, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <span title={item.Name} style={{ color: !scheduleHelper.breakWindowTimesIsFallInShiftTimes(this.props.shiftStartTime, this.props.shiftEndTime, item.BreakWindowStartTime, item.BreakWindowEndTime) && "rgb(244, 67, 54)" }}>
                {item.Name}
              </span>
            </Chip>
          )}
          <IconButton
            data-intercom-target={"Break-Btn-OpenAddBreakDialog"}
            style={{ height: 33, marginTop: 2, display: "inline-block" }}
            onTouchTap={() => {
              const shiftDuration = scheduleHelper.getDurationMiutesFromShiftSimpleTimes(this.props.shiftStartTime, this.props.shiftEndTime)
              shiftDuration === 0 ?
                AppStateStore.setProgressSnackbarContent(strings.Cannot_make_a_break_because_shift_time_is_not_valid) :
                shiftDuration < 5 ?
                  AppStateStore.setProgressSnackbarContent(strings.Cannot_make_a_break_because_shift_time_is_less_than_5min) :
                  this.setState({ openAddBreakDialog: true, editBreak: null })
            }}
          >
            <FontIcon className="fa fa-plus-circle" />
          </IconButton>
        </div>
        {this.state.openAddBreakDialog &&
          <AddBreakDialog
            editBreak={this.state.editBreak}
            breaks={this.props.breaks.filter((item) => this.state.editBreak ? item.Name !== this.state.editBreak.Name : true)}
            restrictedStartTime={this.props.shiftStartTime}
            restrictedEndTime={this.props.shiftEndTime}
            handleClose={() => this.setState({ openAddBreakDialog: false, editBreak: null })}
            handleAdd={this.handleAdd}
            handleUpdate={this.handleUpdate}
          />
        }
      </div >
    )
  }
}